// admin_tools/frontend/src/institutionFetch.js
//
// Threads the selected institution (the `X-Institution-Id` header) through every
// admin-backend fetch, so the multi-institution backend scopes its queries per
// institution. Installed once at app startup (index.js).
//
// Scoped to ADMIN-backend requests only — cross-origin MAIN-backend calls (the eval
// tabs, REACT_APP_MAIN_API_URL) are left untouched, because adding a custom header to
// a cross-origin request triggers a CORS preflight the main backend doesn't allow.

const ADMIN_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8001';
const MAIN_BASE = process.env.REACT_APP_MAIN_API_URL || 'http://localhost:8000';
const STORAGE_KEY = 'admin_institution_id';

export function getInstitutionId() {
  return localStorage.getItem(STORAGE_KEY) || '1'; // default UMD
}

export function setInstitutionId(id) {
  localStorage.setItem(STORAGE_KEY, String(id));
}

export function isAdminRequest(url) {
  const u = String(url || '');
  if (MAIN_BASE && u.startsWith(MAIN_BASE)) return false; // main backend (eval tabs)
  if (ADMIN_BASE && u.startsWith(ADMIN_BASE)) return true; // admin backend (absolute)
  if (u.startsWith('/') || u.startsWith('api/')) return true; // relative → admin (same-origin proxy)
  return false;
}

export function installInstitutionFetch() {
  if (typeof window === 'undefined' || window.__institutionFetchInstalled) return;
  window.__institutionFetchInstalled = true;
  const orig = window.fetch.bind(window);
  window.fetch = (input, init) => {
    const url = typeof input === 'string' ? input : input && input.url;
    if (isAdminRequest(url)) {
      const base = init || {};
      const headers = new Headers(
        base.headers || (typeof input !== 'string' && input ? input.headers : undefined)
      );
      headers.set('X-Institution-Id', getInstitutionId());
      init = { ...base, headers };
    }
    return orig(input, init);
  };
}
